import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.FO_API_PATH,
});

export const updateInstance = (updater) => {
  updater(instance);
};

export default instance;
